<div class="modal_dialog">
  <div class="modal_header">
    <h2>{{data}} {{ 'Batch' | translate }}</h2>
    <button class="btnn close_icon" [mat-dialog-close]> <mat-icon>close</mat-icon> </button>
  </div>
  <div class="modal_body">
    <form>
      <div class="gap_m">
        <div class="form_group w_100">
          <mat-label class="required"
            >{{ 'Batch Name' | translate }}
          </mat-label>

          <mat-form-field appearance="fill">
            <input
              matInput
              placeholder="{{ 'Enter Batch Name' | translate }}"
              class="form_control"
              type="text"
              formControlName="name" />
          </mat-form-field>
        </div>
      </div>
      <div class="submit_btn">
        <button class="btnn btn_primary" [mat-dialog-close]>
          {{ 'Save' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
